'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCurrentChannel = setCurrentChannel;

var _setCurrentChannelAction = require('./setCurrentChannelAction');

function setCurrentChannel(channel) {
  return function (dispatch) {
    dispatch((0, _setCurrentChannelAction.setCurrentChannelAction)(channel));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConversationsActions/setCurrentChannel.js
// module id = 120
// module chunks = 2 3